import React from 'react';
import { ICalendar } from "../../domain/calendars/ICalendar";
import { BaseComponent } from "../base/BaseComponent";
import { appDomain } from "../../domain/domain";
import { Card, Button, ButtonToolbar } from "react-bootstrap";

export interface ICalendarListItemProps {
    calendar: ICalendar;
    onUpdate: (calendar?: ICalendar) => any;
}

export class CalendarListItem extends BaseComponent<ICalendarListItemProps, {}> {
    async deleteCalendar() {
        await appDomain.calendarService.delete(this.props.calendar.id);
        this.props.onUpdate(this.props.calendar);
    }
    render() {
        const c = this.props.calendar;
        const deleteCalendar = this.deleteCalendar.bind(this);
        return (
            <Card style={{ width: '18rem', backgroundColor: 'pink', border: '5px solid lightblue' }}>
                <Card.Body>
                    <Card.Title>{c.name}</Card.Title>
                    <Card.Text>
                        <img src="https://ixxidesign.azureedge.net/media/1332425/Disney-Frozen-Anna-Elsa.jpg?width=562" alt="" style={{ maxWidth: "100%" }}></img>
                        {c.id}
                    </Card.Text>
                    <ButtonToolbar>
                        <Button variant="primary">Openen</Button>
                        <Button variant="danger" onClick={deleteCalendar}>In de prullenbak</Button>
                    </ButtonToolbar>
                </Card.Body>
            </Card>
        );
    }
}
